import React from 'react';
import { HStack, Text } from '@gluestack-ui/themed';
import { useAuthStore } from '../../../auth/store';
import UserMenuComponent from '../../components/UserMenu';

/**
 * Header component for the right side of the admin panel navigation.
 * Displays the current user's name and the user menu.
 */
const AdminHeaderRight: React.FC = () => {
  const logout = useAuthStore((state) => state.logout);
  const user = useAuthStore((state) => state.user);
  const displayName = user ? `${user.firstname || ''} ${user.lastname || ''}`.trim() : '';

  return (
    <HStack alignItems="center" mr="$4" space="md">
      {!!displayName && (
        <Text size="xs" color="$textSubtle" fontWeight="$medium">
          {displayName}
        </Text>
      )}
      <UserMenuComponent user={user} logout={logout} placement="bottom right" />
    </HStack>
  );
};

export default AdminHeaderRight;
